import type { I18nFn } from 'i18n/types/I18nFn';

export const ORG_RELATED_JOB_AREAS = (i18n: I18nFn) => [
  i18n('Sustainability'),
  i18n('Diversity & Inclusion'),
  i18n('Corporate Engagement / Citizenship / Social Responsibility'),
  i18n('Philanthropy'),
  i18n('Healthcare & Healing'),
];
